<template>
  <div id="app">
    <el-form :inline="true" :model="form" class="demo-form-inline">
      <el-row>
        <el-form-item label="暗号">
          <el-input
            v-model="form.uname"
            placeholder="暗号"
            size="mini"
            style="width: 75vw"
          ></el-input>
        </el-form-item>
      </el-row>
      <el-row>
        <el-form-item label="签名">
          <el-input
            v-model="form.sign"
            placeholder="签名"
            size="mini"
            style="width: 75vw"
          ></el-input> </el-form-item></el-row
      ><el-row>
        <el-form-item>
          <el-button type="primary" size="mini" @click="onSubmit"
            >添加暗号</el-button
          >
          <el-button size="mini" @click="generateSign">生成签名密钥</el-button>
          <el-button size="mini" @click="goInfoEditor">返回编辑</el-button>
        </el-form-item></el-row
      >
    </el-form>
    <el-table :data="tableData" style="width: 100%">
      <el-table-column fixed prop="uname" label="暗号" width="70">
      </el-table-column>
      <el-table-column prop="sign" label="签名密钥" width="260">
      </el-table-column>
      <el-table-column fixed="right" label="操作" width="50">
        <template slot-scope="scope">
          <el-button
            @click.native.prevent="deleteRow(scope.$index, tableData)"
            type="text"
            size="small"
          >
            移除
          </el-button>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import { generateAESKey, uuid, decrypt, encrypt } from "@/utils/encrypt";
const password = "123456";
export default {
  methods: {
    deleteRow(index, rows) {
      rows.splice(index, 1);
      localStorage.setItem("data", encrypt(JSON.stringify(rows), password));
    },
    onSubmit() {
      this.form.uid = uuid();
      try {
        let jsonStr = decrypt(localStorage.getItem("data"), password);
        if (jsonStr == null) {
          this.tableData = [this.form];
        } else {
          this.tableData = JSON.parse(jsonStr);
          this.tableData.push({
            uid: this.form.uid,
            uname: this.form.uname,
            sign: this.form.sign,
          });
        }
      } catch (error) {
        this.tableData = [this.form];
      }

      localStorage.setItem(
        "data",
        encrypt(JSON.stringify(this.tableData), password)
      );
    },
    generateSign() {
      this.form.sign = generateAESKey();
    },
    goInfoEditor() {
      window.open("/index.html");
    },
  },
  data() {
    return {
      form: {
        uid: "",
        uname: "",
        sign: "",
      },
      tableData: [],
    };
  },
  mounted() {
    let jsonStr = decrypt(localStorage.getItem("data"), password);
    try {
      this.tableData = JSON.parse(jsonStr);
    } catch (e) {
      this.tableData = [];
    }
  },
};
</script>